import { React, useState } from "react";
import { RightLayoutContainer, PageTitleComp, DetailFields } from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader } from "antd";
import { HaberForm } from "../../styledElements";
import { usePasswordValidation } from "../../../hooks/usePasswordValidation";
import correctIcon from "./../../../Assets/Icons/correct.svg";
import wrongIcon from "./../../../Assets/Icons/wrong.svg";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {changePassword} from "../../../Services/forgotPasswordServices"
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";

const ProfilePasswordData = (props) => {
    const [password, setPassword] = useState({
        firstPassword: "",
        secondPassword: "",
    });
    const [toaster, setToaster] = useState({
        error: "",
        msg: "",
    });
    const [showToaster, setShowToaster] = useState(false);

    const [form] = Form.useForm();

    const [
        validLength,
        hasNumber,
        upperCase,
        lowerCase,
        match,
        specialChar,
    ] = usePasswordValidation({
        firstPassword: password.firstPassword,
        secondPassword: password.secondPassword,
    });

    const setFirst = (event) => {
        setPassword({ ...password, firstPassword: event.target.value });
    };
    const setSecond = (event) => {
        setPassword({ ...password, secondPassword: event.target.value });
    };

    const onFinish = (values)=> {
    changePassword({
      old_password: values.current_password,
      new_password: values.confirm_password,
    })
      .then((resp) => {
        setToaster({
          error: false,
          msg: "Your password is successfully saved",
        });
        setShowToaster(true);
        form.resetFields();
        setTimeout(() => setShowToaster(false), 3000);
      })
      .catch((err) => {
        console.log(err);   
        setToaster({ error: true, msg: err?.data?.msg.split(":")[1].trim() });
        setShowToaster(true);
        setTimeout(() => setShowToaster(false), 3000);
      });
    }
    return (
        <RightLayoutContainer>
            <PageTitleComp>
                <PageHeader
                    ghost={false}
                    title="Change Password"
                ></PageHeader>
            </PageTitleComp>
            <DetailFields>
                <HaberForm>
                    <div className="groupDetailWrap profileWraped changedpd">
                        <Form name="basic" autoComplete="off" className="haberLogin" form={form} onFinish={onFinish}>
                            <Row gutter={[16, 16]} className="groupForm"  style={{borderBottom:"0px"}}>
                                <Col span={24}>
                                    <Row className="centerAlign">
                                        <Col span={10}>
                                            <div className="boxFieldTitle">
                                                <label>Current Password</label>
                                                <p>Enter the current password</p>
                                            </div>
                                        </Col>
                                        <Col span={10}>
                                            <div className="boxFormType">
                                                <Form.Item name="current_password"
                                                    rules={[{ required: true }]} className="lockIcon firstPass"
                                                >
                                                    <Input.Password placeholder="Current password" />
                                                </Form.Item>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="centerAlign">
                                        <Col span={10}>
                                            <div className="boxFieldTitle">
                                                <label>New Password</label>
                                                <p>Enter the new password</p>
                                            </div>
                                        </Col>
                                        <Col span={10}>
                                            <div className="boxFormType">
                                                <Form.Item name="new_password"
                                                    rules={[{ required: true }]}  className="lockIcon firstPass"
                                                >
                                                    <Input.Password placeholder="New password" onChange={setFirst} />
                                                </Form.Item>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="centerAlign">
                                        <Col span={10}>
                                            <div className="boxFieldTitle">
                                                <label>Confirm Password</label>
                                                <p>Enter the confirm password</p>
                                            </div>
                                        </Col>
                                        <Col span={10} style={{display: "block"}}>
                                            <div className="boxFormType">
                                                <Form.Item name="confirm_password"
                                                    rules={[{ required: true }]}  className="lockIcon"
                                                >
                                                    <Input.Password placeholder="Confirm password" onChange={setSecond} />
                                                </Form.Item>
                                            </div>
                                            <ul className="pwdStrength split2">
                                                <li>
                                                    {validLength ? <span><img src={correctIcon} alt="correct" /></span> : <span><img src={wrongIcon} alt="wrong" /></span>} Atleast 8 characters long
                                                </li>
                                                <li>
                                                    {hasNumber ? <span><img src={correctIcon} alt="correct" /></span> : <span><img src={wrongIcon} alt="wrong" /></span>} One numeric charater
                                                </li>
                                                <li>
                                                    {upperCase ? <span><img src={correctIcon} alt="correct" /></span> : <span><img src={wrongIcon} alt="wrong" /></span>} One uppercase character
                                                </li>
                                                <li>
                                                    {lowerCase ? <span><img src={correctIcon} alt="correct" /></span> : <span><img src={wrongIcon} alt="wrong" /></span>} One lowercase character
                                                </li>
                                                <li>
                                                    {specialChar ? <span><img src={correctIcon} alt="correct" /></span> : <span><img src={wrongIcon} alt="wrong" /></span>} One special character{" "}
                                                </li>
                                                <li>{match ? <span><img src={correctIcon} alt="correct" /></span> : <span><img src={wrongIcon} alt="wrong" /></span>} Password matching</li>
                                            </ul>
                                        </Col>
                                    </Row>
                                    <Row className="centerAlign">
                                        <Col span={10}>
                                        </Col>
                                        <Col span={10}>
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit" className="themeBtn"><Iconmoon icon="addcircle" size={14} color="#ffffff" /> Save </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </HaberForm>
            </DetailFields>
            {showToaster && (
                    <AlertContainer
                        closeIcon={true}
                        setClose={showToaster}
                        color={`${toaster.error ? "red" : "green"} toaster`}
                        icon={toaster.error ? alertRed : alertGreen}
                        msg={toaster.msg}
                    />
                )}
        </RightLayoutContainer>
    )
}

export default ProfilePasswordData;